<template>
  <form @submit.prevent="simulateReadout" class="w-128">
    <textarea
      v-model="readouts"
      ref="readouts"
      class="h-72 w-full focus:outline-none focus:border-primary-light focus:bg-white overflow-y-scroll space-y-1 border p-4"
    ></textarea>
    <!-- Action buttons -->
    <div class="flex justify-end space-x-3 pt-5 my-1 border-t">
      <base-button @click="$emit('close')" action="close" context="secondary">
        <base-icon icon="close" />
      </base-button>
      <base-button type="submit" action="save" :loading="pendingRequest">
        <base-icon icon="success" />
      </base-button>
    </div>
  </form>
</template>

<script>
import {BaseButton, BaseIcon} from '@/components/base'
export default {
  components: {
    BaseButton,
    BaseIcon,
  },
  props: {
    tour: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      readouts: null,
      pendingRequest: false,
    }
  },
  mounted() {
    this.$refs.readouts.focus()
  },
  methods: {
    async simulateReadout() {
      this.pendingRequest = true
      try {
        const res = await this.$store.dispatch('tours/simulateImportTour', {
          uuid: this.tour.uuid,
          payload: this.readouts,
        })
        this.$emit('close')
        this.$store.dispatch('app/notification', {type: 'success', group: 'app', text: `updated`})
      } catch (e) {
        this.$store.dispatch('app/notification', {type: 'error', group: 'app', text: `updated`})
        console.log(e)
      } finally {
        this.pendingRequest = false
      }
    },
  },
}
</script>
